module.exports = __webpack_public_path__ + "img/about-m@2x.52daabe0.webp";